import { CloudOff } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgCloudUnknown = mkIcon(CloudOff);